<template>
  <SearchableDropdown
    v-model="selectedTarget"
    class="form-selector form__searchable-dropdown"
    :config="viewModel.dropdownConfig"
    :clearable="clearable"
  />
</template>

<script>
import SearchableDropdown from '../../../core/components/SearchableDropdown/SearchableDropdown.vue';
import { TargetDropdownViewModel } from '../models/TargetDropdownViewModel';

export default {
  name: 'TargetDropdown',
  components: { SearchableDropdown },
  props: {
    value: {
      type: [String, Object],
      default: null
    },
    clearable: {
      type: Boolean,
      default: true
    }

  },

  data() {
    return {
      viewModel: new TargetDropdownViewModel(this.value)
    };
  },

  computed: {

    selectedTarget: {
      get() {
        return this.viewModel.selectedTarget;
      },
      set(value) {
        if (value !== this.viewModel.selectedTarget) {
          this.viewModel.selectedTarget = value;
          this.$emit('input', value);
          this.$emit('change', value);
        }
      }
    }
  },
  created() {
    this.viewModel?.loadConversionSettings();
  },
  mounted() {
    this.viewModel.loadConversionSettings();
  }
};
</script>
